import { ChainId } from "astra-sdk-core";

export const FACTORY_ADDRESS = "0x1F98431c8aD98523631AE4a59f267346ea31F984";

export const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";

// @deprecated please use poolInitCodeHash(chainId: ChainId)
export const POOL_INIT_CODE_HASH = "0x203c8ec649b23b7faf9b73ccadfb1a67af52a097119c82801f4947ec5deb6c04";

export function poolInitCodeHash(chainId?: ChainId): string {
  switch (chainId) {
    case ChainId.MAINNET:
    case ChainId.TESTNET:
    case ChainId.DEVNET:
      return "0x203c8ec649b23b7faf9b73ccadfb1a67af52a097119c82801f4947ec5deb6c04";
    default:
      return POOL_INIT_CODE_HASH;
  }
}

/**
 * The default factory enabled fee amounts, denominated in hundredths of bips.
 */
export enum FeeAmount {
  LOWEST = 100,
  LOW_200 = 200,
  LOW_300 = 300,
  LOW_400 = 400,
  LOW = 500,
  MEDIUM = 3000,
  HIGH = 10000,
}

/**
 * The default factory tick spacings by fee amount.
 */
export const TICK_SPACINGS: { [amount in FeeAmount]: number } = {
  [FeeAmount.LOWEST]: 1,
  [FeeAmount.LOW_200]: 4,
  [FeeAmount.LOW_300]: 6,
  [FeeAmount.LOW_400]: 8,
  [FeeAmount.LOW]: 10,
  [FeeAmount.MEDIUM]: 60,
  [FeeAmount.HIGH]: 200
};
